import {
    SET_CATALOG_REMOVE_CAPACITY,
    SET_CATALOG_REMOVE_DRIVE_TRAIN,
    SET_CATALOG_REMOVE_EQ_CLASS_CODE,
    SET_CATALOG_REMOVE_MAKE,
    SET_CATALOG_REMOVE_NO_OF_DOORS,
    SET_CATALOG_REMOVE_POWER_TYPE,
    SET_CATALOG_REMOVE_UPFIT,
    SET_CATALOG_REMOVE_VEHICLE_LEVEL,
    SET_CATALOG_REMOVE_YEAR,
    SET_CATALOG_UPDATE_CAPACITY,
    SET_CATALOG_UPDATE_CAPACITY_SAVE,
    SET_CATALOG_UPDATE_CAPACITY_VALIDATE,
    SET_CATALOG_UPDATE_DRIVE_TRAIN,
    SET_CATALOG_UPDATE_DRIVE_TRAIN_SAVE,
    SET_CATALOG_UPDATE_DRIVE_TRAIN_VALIDATE,
    SET_CATALOG_UPDATE_EQ_CLASS_CODE,
    SET_CATALOG_UPDATE_EQ_CLASS_CODE_SAVE,
    SET_CATALOG_UPDATE_EQ_CLASS_CODE_VALIDATE,
    SET_CATALOG_UPDATE_MAKE,
    SET_CATALOG_UPDATE_MAKE_SAVE,
    SET_CATALOG_UPDATE_MAKE_VALIDATE,
    SET_CATALOG_UPDATE_MODEL_SAVE,
    SET_CATALOG_UPDATE_MODEL_VALIDATE,
    SET_CATALOG_UPDATE_NO_OF_DOORS,
    SET_CATALOG_UPDATE_NO_OF_DOORS_SAVE,
    SET_CATALOG_UPDATE_NO_OF_DOORS_VALIDATE,
    SET_CATALOG_UPDATE_POWER_TYPE,
    SET_CATALOG_UPDATE_POWER_TYPE_SAVE,
    SET_CATALOG_UPDATE_POWER_TYPE_VALIDATE,
    SET_CATALOG_UPDATE_UPFIT,
    SET_CATALOG_UPDATE_UPFIT_SAVE,
    SET_CATALOG_UPDATE_UPFIT_VALIDATE,
    SET_CATALOG_UPDATE_VEHICLE_LEVEL,
    SET_CATALOG_UPDATE_VEHICLE_LEVEL_SAVE,
    SET_CATALOG_UPDATE_VEHICLE_LEVEL_VALIDATE,
    SET_CATALOG_UPDATE_YEAR,
    SET_CATALOG_UPDATE_YEAR_SAVE,
    SET_CATALOG_UPDATE_YEAR_VALIDATE,

    SET_BUDGETING_PERCENT_LIST,
    IS_BUDGETING_PERCENT_OPTION_SAVED,
    IS_BUDGETING_PERCENT_OPTION_VALID,
    IS_BUDGETING_PERCENT_OPTION_DELETED,

    SET_USEFUL_LIFE_LIST,
    IS_USEFUL_LIFE_OPTION_SAVED,
    IS_USEFUL_LIFE_OPTION_VALID,
    IS_USEFUL_LIFE_OPTION_DELETED,

    SET_CATALOG_UPDATE_MODEL,
    SET_CATALOG_REMOVE_MODEL,
    SET_CATALOG_UPDATE_STATE_AVAILABILITY,
    SET_CATALOG_UPDATE_STATE_AVAILABILITY_SAVE,
    SET_CATALOG_UPDATE_STATE_AVAILABILITY_VALIDATE,
    SET_CATALOG_REMOVE_STATE_AVAILABILITY,
    SET_CATALOG_UPDATE_PROGRAM_STATUS,
    SET_CATALOG_UPDATE_PROGRAM_STATUS_SAVE,
    SET_CATALOG_UPDATE_PROGRAM_STATUS_VALIDATE,
    SET_CATALOG_REMOVE_PROGRAM_STATUS,
    SET_CATALOG_UPDATE_ANNUAL_HOURS,
    SET_CATALOG_UPDATE_ANNUAL_HOURS_SAVE,
    SET_CATALOG_UPDATE_ANNUAL_HOURS_VALIDATE,
    SET_CATALOG_REMOVE_ANNUAL_HOURS,
    SET_CATALOG_UPDATE_DECK_SIZE,
    SET_CATALOG_UPDATE_DECK_SIZE_SAVE,
    SET_CATALOG_UPDATE_DECK_SIZE_VALIDATE,
    SET_CATALOG_REMOVE_DECK_SIZE,
    SET_CATALOG_UPDATE_DECK_TYPE,
    SET_CATALOG_UPDATE_DECK_TYPE_SAVE,
    SET_CATALOG_UPDATE_DECK_TYPE_VALIDATE,
    SET_CATALOG_REMOVE_DECK_TYPE,
    SET_CATALOG_UPDATE_LENGTH,
    SET_CATALOG_UPDATE_LENGTH_SAVE,
    SET_CATALOG_UPDATE_LENGTH_VALIDATE,
    SET_CATALOG_REMOVE_LENGTH,
    SET_CATALOG_UPDATE_SIZE,
    SET_CATALOG_UPDATE_SIZE_SAVE,
    SET_CATALOG_UPDATE_SIZE_VALIDATE,
    SET_CATALOG_REMOVE_SIZE,
    SET_CATALOG_UPDATE_AUTONOMOUS,
    SET_CATALOG_UPDATE_AUTONOMOUS_SAVE,
    SET_CATALOG_UPDATE_AUTONOMOUS_VALIDATE,
    SET_CATALOG_REMOVE_AUTONOMOUS,
    SET_CATALOG_UPDATE_CATEGORY,
    SET_CATALOG_UPDATE_CATEGORY_SAVE,
    SET_CATALOG_UPDATE_CATEGORY_VALIDATE,
    SET_CATALOG_REMOVE_CATEGORY,
    SET_CATALOG_UPDATE_CATEGORY_TYPE,
    SET_CATALOG_UPDATE_CATEGORY_TYPE_SAVE,
    SET_CATALOG_UPDATE_CATEGORY_TYPE_VALIDATE,
    SET_CATALOG_REMOVE_CATEGORY_TYPE,
    SET_CATALOG_UPDATE_CATEGORY2,
    SET_CATALOG_UPDATE_CATEGORY2_SAVE,
    SET_CATALOG_UPDATE_CATEGORY2_VALIDATE,
    SET_CATALOG_REMOVE_CATEGORY2,

    //Type
    SET_CATALOG_UPDATE_TYPE,
    SET_CATALOG_UPDATE_TYPE_SAVE,
    SET_CATALOG_UPDATE_TYPE_VALIDATE,
    SET_CATALOG_REMOVE_TYPE,

    //Tags
    SET_TAGS_LIST,
    IS_TAGS_OPTION_SAVED,
    IS_TAGS_OPTION_VALID,
    IS_TAGS_OPTION_DELETED,

    //capacity edit 
    SET_EDIT_CATALOG_VEHICLE_CAPACITY,

    //Vehicle Class
    SET_CATALOG_UPDATE_VEHICLE_CLASS,
    SET_CATALOG_UPDATE_VEHICLE_CLASS_SAVE,
    SET_CATALOG_UPDATE_VEHICLE_CLASS_VALIDATE,
    SET_CATALOG_REMOVE_VEHICLE_CLASS,

    //Group Type
    SET_CATALOG_UPDATE_GROUP_TYPE,
    SET_CATALOG_UPDATE_GROUP_TYPE_SAVE,
    SET_CATALOG_UPDATE_GROUP_TYPE_VALIDATE,
    SET_CATALOG_REMOVE_GROUP_TYPE,

    //Class Type
    SET_CATALOG_UPDATE_CLASS_TYPE,
    SET_CATALOG_UPDATE_CLASS_TYPE_SAVE,
    SET_CATALOG_UPDATE_CLASS_TYPE_VALIDATE,
    SET_CATALOG_REMOVE_CLASS_TYPE,

     //Gross Weight
     SET_CATALOG_UPDATE_GROSS_WEIGHT,
     SET_CATALOG_UPDATE_GROSS_WEIGHT_SAVE,
     SET_CATALOG_UPDATE_GROSS_WEIGHT_VALIDATE,
     SET_CATALOG_REMOVE_GROSS_WEIGHT,

     ///Trim
     SET_CATALOG_UPDATE_TRIM,
     SET_CATALOG_UPDATE_TRIM_SAVE,
     SET_CATALOG_UPDATE_TRIM_VALIDATE,
     SET_CATALOG_REMOVE_TRIM,
} from "./CatalogItemDropDownUpdateType";

const initialState = {
    catalogUpdateNoOfDoors: [],
    isCatalogUpdateNoOfDoorSaved: null,
    isCatalogNoOfDoorRemoved: null,
    isCatalogUpdateNoOfDoorValid: null,
    catalogUpdateYear: [],
    isCatalogUpdateYearSaved: null,
    isCatalogUpdateYearValid: null,
    isCatalogYearRemoved: null,
    catalogUpdateVehicleClass: [],
    isCatalogUpdateVehicleClassSaved: null,
    isCatalogUpdateVehicleClassValid: null,
    isCatalogVehicleClassRemoved: null,
    catalogUpdateCapacity: [],
    isCatalogUpdateCapacitySaved: null,
    isCatalogUpdateCapacityValid: null,
    isCatalogCapacityRemoved: null,
    catalogUpdateUpfit: [],
    isCatalogUpdateUpfitSaved: null,
    isCatalogUpdateUpfitValid: null,
    isCatalogUpfitRemoved: null,
    catalogUpdateDriveTrain: [],
    isCatalogUpdateDriveTrainSaved: null,
    isCatalogUpdateDriveTrainValid: null,
    isCatalogDriveTrainRemoved: null,
    catalogUpdatePowerType: [],
    isCatalogUpdatePowerTypeSaved: null,
    isCatalogUpdatePowerTypeValid: null,
    isCatalogPowerTypeRemoved: null,
    catalogUpdateVehicleLevel: [],
    isCatalogUpdateVehicleLevelSaved: null,
    isCatalogUpdateVehicleLevelValid: null,
    isCatalogVehicleLevelRemoved: null,
    catalogUpdateEqClassCode: [],
    isCatalogUpdateEqClassCodeSaved: null,
    isCatalogUpdateEqClassCodeValid: null,
    isCatalogEqClassCodeRemoved: null,
    catalogUpdateMake: [],
    isCatalogUpdateMakeSaved: null,
    isCatalogUpdateMakeValid: null,
    isCatalogMakeRemoved: null,
    catalogUpdateStateAvailability: [],
    isCatalogUpdateStateAvailabilitySaved: null,
    isCatalogUpdateStateAvailabilityValid: null,
    isCatalogStateAvailabilityRemoved: null,
    isCatalogUpdateModelSaved: null,
    isCatalogUpdateModelValid: null,
    catalogUpdateModel: [],
    isCatalogModelRemoved: null,
    catalogUpdateProgramStatus: [],
    isCatalogUpdateProgramStatusSaved: null,
    isCatalogUpdateProgramStatusValid: null,
    isCatalogProgramStatusRemoved: null,
    catalogUpdateAnnualHours: [],
    isCatalogUpdateAnnualHoursSaved: null,
    isCatalogUpdateAnnualHoursValid: null,
    isCatalogAnnualHoursRemoved: null,
    catalogUpdateDeckSize: [],
    isCatalogUpdateDeckSizeSaved: null,
    isCatalogUpdateDeckSizeValid: null,
    isCatalogDeckSizeRemoved: null,
    catalogUpdateDeckType: [],
    isCatalogUpdateDeckTypeSaved: null,
    isCatalogUpdateDeckTypeValid: null,
    isCatalogDeckTypeRemoved: null,
    catalogUpdateSize: [],
    isCatalogUpdateSizeSaved: null,
    isCatalogUpdateSizeValid: null,
    isCatalogSizeRemoved: null,
    catalogUpdateLength: [],
    isCatalogUpdateLengthSaved: null,
    isCatalogUpdateLengthValid: null,
    isCatalogLengthRemoved: null,
    catalogUpdateAutonomous: [],
    isCatalogUpdateAutonomousSaved: null,
    isCatalogUpdateAutonomousValid: null,
    isCatalogAutonomousRemoved: null,
    catalogUpdateCategory: [],
    isCatalogUpdateCategorySaved: null,
    isCatalogUpdateCategoryValid: null,
    isCatalogCategoryRemoved: null,
    catalogUpdateCategoryType: [],
    isCatalogUpdateCategoryTypeSaved: null,
    isCatalogUpdateCategoryTypeValid: null,
    isCatalogCategoryTypeRemoved: null,
    catalogUpdateCategory2: [],
    isCatalogUpdateCategory2Saved: null,
    isCatalogUpdateCategory2Valid: null,
    isCatalogCategory2Removed: null,
    catalogUpdateType:[],
    isCatalogUpdateTypeSaved: null,
    isCatalogUpdateTypeValid: null,
    isCatalogTypeRemoved: null,
    isVehicleCapacityEdited: null,
    catalogUpdateGroupType: [],
    isCatalogUpdateGroupTypeSaved: null,
    isCatalogUpdateGroupTypeValid: null,
    isCatalogGroupTypeRemoved: null,
    catalogUpdateClassType: [],
    isCatalogUpdateClassTypeSaved: null,
    isCatalogUpdateClassTypeValid: null,
    isCatalogClassTypeRemoved: null,
    catalogUpdateGrossWeight: [],
    isCatalogUpdateGrossWeightSaved: null,
    isCatalogUpdateGrossWeightValid: null,
    isCatalogGrossWeightRemoved: null,
    catalogUpdateTrim: [],
    isCatalogUpdateTrimSaved: null,
    isCatalogUpdateTrimValid: null,
    isCatalogTrimRemoved: null,
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_CATALOG_UPDATE_NO_OF_DOORS:
            return {
                ...state,
                catalogUpdateNoOfDoors: action.catalogUpdateNoOfDoors,
            };
        case SET_CATALOG_UPDATE_NO_OF_DOORS_SAVE:
            return {
                ...state,
                isCatalogUpdateNoOfDoorSaved: action.isCatalogUpdateNoOfDoorSaved,
            };
        case SET_CATALOG_UPDATE_NO_OF_DOORS_VALIDATE:
            return {
                ...state,
                isCatalogUpdateNoOfDoorValid: action.isCatalogUpdateNoOfDoorValid,
            };
        case SET_CATALOG_REMOVE_NO_OF_DOORS:
            return {
                ...state,
                isCatalogNoOfDoorRemoved: action.isCatalogNoOfDoorRemoved,
            };

        case SET_CATALOG_UPDATE_YEAR:
            return {
                ...state,
                catalogUpdateYear: action.catalogUpdateYear,
            };
        case SET_CATALOG_UPDATE_YEAR_SAVE:
            return {
                ...state,
                isCatalogUpdateYearSaved: action.isCatalogUpdateYearSaved,
            };
        case SET_CATALOG_UPDATE_YEAR_VALIDATE:
            return {
                ...state,
                isCatalogUpdateYearValid: action.isCatalogUpdateYearValid,
            };
        case SET_CATALOG_REMOVE_YEAR:
            return {
                ...state,
                isCatalogYearRemoved: action.isCatalogYearRemoved,
            };
        case SET_CATALOG_UPDATE_CAPACITY:
            return {
                ...state,
                catalogUpdateCapacity: action.catalogUpdateCapacity,
            };
        case SET_CATALOG_UPDATE_CAPACITY_SAVE:
            return {
                ...state,
                isCatalogUpdateCapacitySaved: action.isCatalogUpdateCapacitySaved,
            };
        case SET_CATALOG_UPDATE_CAPACITY_VALIDATE:
            return {
                ...state,
                isCatalogUpdateCapacityValid: action.isCatalogUpdateCapacityValid,
            };
        case SET_CATALOG_REMOVE_CAPACITY:
            return {
                ...state,
                isCatalogCapacityRemoved: action.isCatalogCapacityRemoved,
            };
        case SET_CATALOG_UPDATE_UPFIT:
            return {
                ...state,
                catalogUpdateUpfit: action.catalogUpdateUpfit,
            };
        case SET_CATALOG_UPDATE_UPFIT_SAVE:
            return {
                ...state,
                isCatalogUpdateUpfitSaved: action.isCatalogUpdateUpfitSaved,
            };
        case SET_CATALOG_UPDATE_UPFIT_VALIDATE:
            return {
                ...state,
                isCatalogUpdateUpfitValid: action.isCatalogUpdateUpfitValid,
            };
        case SET_CATALOG_REMOVE_UPFIT:
            return {
                ...state,
                isCatalogUpfitRemoved: action.isCatalogUpfitRemoved,
            };
        case SET_CATALOG_UPDATE_DRIVE_TRAIN:
            return {
                ...state,
                catalogUpdateDriveTrain: action.catalogUpdateDriveTrain,
            };
        case SET_CATALOG_UPDATE_DRIVE_TRAIN_SAVE:
            return {
                ...state,
                isCatalogUpdateDriveTrainSaved: action.isCatalogUpdateDriveTrainSaved,
            };
        case SET_CATALOG_UPDATE_DRIVE_TRAIN_VALIDATE:
            return {
                ...state,
                isCatalogUpdateDriveTrainValid: action.isCatalogUpdateDriveTrainValid,
            };
        case SET_CATALOG_REMOVE_DRIVE_TRAIN:
            return {
                ...state,
                isCatalogDriveTrainRemoved: action.isCatalogDriveTrainRemoved,
            };
        case SET_CATALOG_UPDATE_POWER_TYPE:
            return {
                ...state,
                catalogUpdatePowerType: action.catalogUpdatePowerType,
            };
        case SET_CATALOG_UPDATE_POWER_TYPE_SAVE:
            return {
                ...state,
                isCatalogUpdatePowerTypeSaved: action.isCatalogUpdatePowerTypeSaved,
            };
        case SET_CATALOG_UPDATE_POWER_TYPE_VALIDATE:
            return {
                ...state,
                isCatalogUpdatePowerTypeValid: action.isCatalogUpdatePowerTypeValid,
            };
        case SET_CATALOG_REMOVE_POWER_TYPE:
            return {
                ...state,
                isCatalogPowerTypeRemoved: action.isCatalogPowerTypeRemoved,
            };
        case SET_CATALOG_UPDATE_VEHICLE_LEVEL:
            return {
                ...state,
                catalogUpdateVehicleLevel: action.catalogUpdateVehicleLevel,
            };
        case SET_CATALOG_UPDATE_VEHICLE_LEVEL_SAVE:
            return {
                ...state,
                isCatalogUpdateVehicleLevelSaved: action.isCatalogUpdateVehicleLevelSaved,
            };
        case SET_CATALOG_UPDATE_VEHICLE_LEVEL_VALIDATE:
            return {
                ...state,
                isCatalogUpdateVehicleLevelValid: action.isCatalogUpdateVehicleLevelValid,
            };
        case SET_CATALOG_REMOVE_VEHICLE_LEVEL:
            return {
                ...state,
                isCatalogVehicleLevelRemoved: action.isCatalogVehicleLevelRemoved,
            };

        case SET_CATALOG_UPDATE_EQ_CLASS_CODE:
            return {
                ...state,
                catalogUpdateEqClassCode: action.catalogUpdateEqClassCode,
            };
        case SET_CATALOG_UPDATE_EQ_CLASS_CODE_SAVE:
            return {
                ...state,
                isCatalogUpdateEqClassCodeSaved: action.isCatalogUpdateEqClassCodeSaved,
            };
        case SET_CATALOG_UPDATE_EQ_CLASS_CODE_VALIDATE:
            return {
                ...state,
                isCatalogUpdateEqClassCodeValid: action.isCatalogUpdateEqClassCodeValid,
            };
        case SET_CATALOG_REMOVE_EQ_CLASS_CODE:
            return {
                ...state,
                isCatalogEqClassCodeRemoved: action.isCatalogEqClassCodeRemoved,
            };
        case SET_CATALOG_UPDATE_MAKE:
            return {
                ...state,
                catalogUpdateMake: action.catalogUpdateMake,
            };
        case SET_CATALOG_UPDATE_MAKE_SAVE:
            return {
                ...state,
                isCatalogUpdateMakeSaved: action.isCatalogUpdateMakeSaved,
            };
        case SET_CATALOG_UPDATE_MAKE_VALIDATE:
            return {
                ...state,
                isCatalogUpdateMakeValid: action.isCatalogUpdateMakeValid,
            };
        case SET_CATALOG_REMOVE_MAKE:
            return {
                ...state,
                isCatalogMakeRemoved: action.isCatalogMakeRemoved,
            };
        case SET_CATALOG_UPDATE_STATE_AVAILABILITY:
            return {
                ...state,
                catalogUpdateStateAvailability: action.catalogUpdateStateAvailability,
            };
        case SET_CATALOG_UPDATE_STATE_AVAILABILITY_SAVE:
            return {
                ...state,
                isCatalogUpdateStateAvailabilitySaved: action.isCatalogUpdateStateAvailabilitySaved,
            };
        case SET_CATALOG_UPDATE_STATE_AVAILABILITY_VALIDATE:
            return {
                ...state,
                isCatalogUpdateStateAvailabilityValid: action.isCatalogUpdateStateAvailabilityValid,
            };
        case SET_CATALOG_REMOVE_STATE_AVAILABILITY:
            return {
                ...state,
                isCatalogStateAvailabilityRemoved: action.isCatalogStateAvailabilityRemoved,
            };
        case SET_CATALOG_UPDATE_MODEL_SAVE:
            return {
                ...state,
                isCatalogUpdateModelSaved: action.isCatalogUpdateModelSaved,
            };
        case SET_CATALOG_UPDATE_MODEL_VALIDATE:
            return {
                ...state,
                isCatalogUpdateModelValid: action.isCatalogUpdateModelValid,
            };
        case SET_CATALOG_UPDATE_MODEL:
            return {
                ...state,
                catalogUpdateModel: action.catalogUpdateModel,
            };
        case SET_CATALOG_REMOVE_MODEL:
            return {
                ...state,
                isCatalogModelRemoved: action.isCatalogModelRemoved,
            };
        case SET_BUDGETING_PERCENT_LIST:
            return {
                ...state,
                budgetingPercentOptionsList: action.list,
            };
        case IS_BUDGETING_PERCENT_OPTION_SAVED:
            return {
                ...state,
                isBudgetingPercentOptionsSaved: action.value,
            };
        case IS_BUDGETING_PERCENT_OPTION_VALID:
            return {
                ...state,
                isBudgetingPercentOptionsValid: action.value,
            };
        case IS_BUDGETING_PERCENT_OPTION_DELETED:
            return {
                ...state,
                isBudgetingPercentOptionsDeleted: action.value,
            };
        case SET_USEFUL_LIFE_LIST:
            return {
                ...state,
                usefulLifeOptionsList: action.list,
            };
        case IS_USEFUL_LIFE_OPTION_SAVED:
            return {
                ...state,
                isUsefulLifeOptionsSaved: action.value,
            };
        case IS_USEFUL_LIFE_OPTION_VALID:
            return {
                ...state,
                isUsefulLifeOptionsValid: action.value,
            };
        case IS_USEFUL_LIFE_OPTION_DELETED:
            return {
                ...state,
                isUsefulLifeOptionsDeleted: action.value,
            };
        case SET_CATALOG_UPDATE_PROGRAM_STATUS:
            return {
                ...state,
                catalogUpdateProgramStatus: action.catalogUpdateProgramStatus,
            };
        case SET_CATALOG_UPDATE_PROGRAM_STATUS_SAVE:
            return {
                ...state,
                isCatalogUpdateProgramStatusSaved: action.isCatalogUpdateProgramStatusSaved,
            };
        case SET_CATALOG_UPDATE_PROGRAM_STATUS_VALIDATE:
            return {
                ...state,
                isCatalogUpdateProgramStatusValid: action.isCatalogUpdateProgramStatusValid,
            };
        case SET_CATALOG_REMOVE_PROGRAM_STATUS:
            return {
                ...state,
                isCatalogProgramStatusRemoved: action.isCatalogProgramStatusRemoved,
            };
        case SET_CATALOG_UPDATE_ANNUAL_HOURS:
            return {
                ...state,
                catalogUpdateAnnualHours: action.catalogUpdateAnnualHours,
            };
        case SET_CATALOG_UPDATE_ANNUAL_HOURS_SAVE:
            return {
                ...state,
                isCatalogUpdateAnnualHoursSaved: action.isCatalogUpdateAnnualHoursSaved,
            };
        case SET_CATALOG_UPDATE_ANNUAL_HOURS_VALIDATE:
            return {
                ...state,
                isCatalogUpdateAnnualHoursValid: action.isCatalogUpdateAnnualHoursValid,
            };
        case SET_CATALOG_REMOVE_ANNUAL_HOURS:
            return {
                ...state,
                isCatalogAnnualHoursRemoved: action.isCatalogAnnualHoursRemoved,
            };
        case SET_CATALOG_UPDATE_DECK_SIZE:
            return {
                ...state,
                catalogUpdateDeckSize: action.catalogUpdateDeckSize,
            };
        case SET_CATALOG_UPDATE_DECK_SIZE_SAVE:
            return {
                ...state,
                isCatalogUpdateDeckSizeSaved: action.isCatalogUpdateDeckSizeSaved,
            };
        case SET_CATALOG_UPDATE_DECK_SIZE_VALIDATE:
            return {
                ...state,
                isCatalogUpdateDeckSizeValid: action.isCatalogUpdateDeckSizeValid,
            };
        case SET_CATALOG_REMOVE_DECK_SIZE:
            return {
                ...state,
                isCatalogDeckSizeRemoved: action.isCatalogDeckSizeRemoved,
            };
        case SET_CATALOG_UPDATE_DECK_TYPE:
            return {
                ...state,
                catalogUpdateDeckType: action.catalogUpdateDeckType,
            };
        case SET_CATALOG_UPDATE_DECK_TYPE_SAVE:
            return {
                ...state,
                isCatalogUpdateDeckTypeSaved: action.isCatalogUpdateDeckTypeSaved,
            };
        case SET_CATALOG_UPDATE_DECK_TYPE_VALIDATE:
            return {
                ...state,
                isCatalogUpdateDeckTypeValid: action.isCatalogUpdateDeckTypeValid,
            };
        case SET_CATALOG_REMOVE_DECK_TYPE:
            return {
                ...state,
                isCatalogDeckTypeRemoved: action.isCatalogDeckTypeRemoved,
            };
        case SET_CATALOG_UPDATE_SIZE:
            return {
                ...state,
                catalogUpdateSize: action.catalogUpdateSize,
            };
        case SET_CATALOG_UPDATE_SIZE_SAVE:
            return {
                ...state,
                isCatalogUpdateSizeSaved: action.isCatalogUpdateSizeSaved,
            };
        case SET_CATALOG_UPDATE_SIZE_VALIDATE:
            return {
                ...state,
                isCatalogUpdateSizeValid: action.isCatalogUpdateSizeValid,
            };
        case SET_CATALOG_REMOVE_SIZE:
            return {
                ...state,
                isCatalogSizeRemoved: action.isCatalogSizeRemoved,
            };
        case SET_CATALOG_UPDATE_LENGTH:
            return {
                ...state,
                catalogUpdateLength: action.catalogUpdateLength,
            };
        case SET_CATALOG_UPDATE_LENGTH_SAVE:
            return {
                ...state,
                isCatalogUpdateLengthSaved: action.isCatalogUpdateLengthSaved,
            };
        case SET_CATALOG_UPDATE_LENGTH_VALIDATE:
            return {
                ...state,
                isCatalogUpdateLengthValid: action.isCatalogUpdateLengthValid,
            };
        case SET_CATALOG_REMOVE_LENGTH:
            return {
                ...state,
                isCatalogLengthRemoved: action.isCatalogLengthRemoved,
            };
        case SET_CATALOG_UPDATE_AUTONOMOUS:
            return {
                ...state,
                catalogUpdateAutonomous: action.catalogUpdateAutonomous,
            };
        case SET_CATALOG_UPDATE_AUTONOMOUS_SAVE:
            return {
                ...state,
                isCatalogUpdateAutonomousSaved: action.isCatalogUpdateAutonomousSaved,
            };
        case SET_CATALOG_UPDATE_AUTONOMOUS_VALIDATE:
            return {
                ...state,
                isCatalogUpdateAutonomousValid: action.isCatalogUpdateAutonomousValid,
            };
        case SET_CATALOG_REMOVE_AUTONOMOUS:
            return {
                ...state,
                isCatalogAutonomousRemoved: action.isCatalogAutonomousRemoved,
            };
        case SET_CATALOG_UPDATE_CATEGORY:
            return {
                ...state,
                catalogUpdateCategory: action.catalogUpdateCategory,
            };
        case SET_CATALOG_UPDATE_CATEGORY_SAVE:
            return {
                ...state,
                isCatalogUpdateCategorySaved: action.isCatalogUpdateCategorySaved,
            };
        case SET_CATALOG_UPDATE_CATEGORY_VALIDATE:
            return {
                ...state,
                isCatalogUpdateCategoryValid: action.isCatalogUpdateCategoryValid,
            };
        case SET_CATALOG_REMOVE_CATEGORY:
            return {
                ...state,
                isCatalogCategoryRemoved: action.isCatalogCategoryRemoved,
            };
        case SET_CATALOG_UPDATE_CATEGORY_TYPE:
            return {
                ...state,
                catalogUpdateCategoryType: action.catalogUpdateCategoryType,
            };
        case SET_CATALOG_UPDATE_CATEGORY_TYPE_SAVE:
            return {
                ...state,
                isCatalogUpdateCategoryTypeSaved: action.isCatalogUpdateCategoryTypeSaved,
            };
        case SET_CATALOG_UPDATE_CATEGORY_TYPE_VALIDATE:
            return {
                ...state,
                isCatalogUpdateCategoryTypeValid: action.isCatalogUpdateCategoryTypeValid,
            };
        case SET_CATALOG_REMOVE_CATEGORY_TYPE:
            return {
                ...state,
                isCatalogCategoryTypeRemoved: action.isCatalogCategoryTypeRemoved,
            };
        case SET_CATALOG_UPDATE_CATEGORY2:
            return {
                ...state,
                catalogUpdateCategory2: action.catalogUpdateCategory2,
            };
        case SET_CATALOG_UPDATE_CATEGORY2_SAVE:
            return {
                ...state,
                isCatalogUpdateCategory2Saved: action.isCatalogUpdateCategory2Saved,
            };
        case SET_CATALOG_UPDATE_CATEGORY2_VALIDATE:
            return {
                ...state,
                isCatalogUpdateCategory2Valid: action.isCatalogUpdateCategory2Valid,
            };
        case SET_CATALOG_REMOVE_CATEGORY2:
            return {
                ...state,
                isCatalogCategory2Removed: action.isCatalogCategory2Removed,
            };
        case SET_CATALOG_UPDATE_TYPE:
            return {
                ...state,
                catalogUpdateType: action.catalogUpdateType,
            };
        case SET_CATALOG_UPDATE_TYPE_SAVE:
            return {
                ...state,
                isCatalogUpdateTypeSaved: action.isCatalogUpdateTypeSaved,
            };
        case SET_CATALOG_UPDATE_TYPE_VALIDATE:
            return {
                ...state,
                isCatalogUpdateTypeValid: action.isCatalogUpdateTypeValid,
            };
        case SET_CATALOG_REMOVE_TYPE:
            return {
                ...state,
                isCatalogTypeRemoved: action.isCatalogTypeRemoved,
            };
            case SET_TAGS_LIST:
            return {
                ...state,
                tagsOptionsList: action.list,
            };
        case IS_TAGS_OPTION_SAVED:
            return {
                ...state,
                isTagsOptionsSaved: action.value,
            };
        case IS_TAGS_OPTION_VALID:
            return {
                ...state,
                isTagsOptionsValid: action.value,
            };
        case IS_TAGS_OPTION_DELETED:
            return {
                ...state,
                isTagsOptionsDeleted: action.value,
            };
        case SET_EDIT_CATALOG_VEHICLE_CAPACITY:
            return {
                ...state,
                isVehicleCapacityEdited: action.isVehicleCapacityEdited,
            };
        case SET_CATALOG_UPDATE_VEHICLE_CLASS:
            return {
                ...state,
                catalogUpdateVehicleClass: action.catalogUpdateVehicleClass,
            };
        case SET_CATALOG_UPDATE_VEHICLE_CLASS_SAVE:
            return {
                ...state,
                isCatalogUpdateVehicleClassSaved: action.isCatalogUpdateVehicleClassSaved,
            };
        case SET_CATALOG_UPDATE_VEHICLE_CLASS_VALIDATE:
            return {
                ...state,
                isCatalogUpdateVehicleClassValid: action.isCatalogUpdateVehicleClassValid,
            };
        case SET_CATALOG_REMOVE_VEHICLE_CLASS:
            return {
                ...state,
                isCatalogVehicleClassRemoved: action.isCatalogVehicleClassRemoved,
            };
        case SET_CATALOG_UPDATE_GROUP_TYPE:
            return {
                ...state,
                catalogUpdateGroupType: action.catalogUpdateGroupType,
            };
        case SET_CATALOG_UPDATE_GROUP_TYPE_SAVE:
            return {
                ...state,
                isCatalogUpdateGroupTypeSaved: action.isCatalogUpdateGroupTypeSaved,
            };
        case SET_CATALOG_UPDATE_GROUP_TYPE_VALIDATE:
            return {
                ...state,
                isCatalogUpdateGroupTypeValid: action.isCatalogUpdateGroupTypeValid,
            };
        case SET_CATALOG_REMOVE_GROUP_TYPE:
            return {
                ...state,
                isCatalogGroupTypeRemoved: action.isCatalogGroupTypeRemoved,
            };
        case SET_CATALOG_UPDATE_CLASS_TYPE:
            return {
                ...state,
                catalogUpdateClassType: action.catalogUpdateClassType,
            };
        case SET_CATALOG_UPDATE_CLASS_TYPE_SAVE:
            return {
                ...state,
                isCatalogUpdateClassTypeSaved: action.isCatalogUpdateClassTypeSaved,
            };
        case SET_CATALOG_UPDATE_CLASS_TYPE_VALIDATE:
            return {
                ...state,
                isCatalogUpdateClassTypeValid: action.isCatalogUpdateClassTypeValid,
            };
        case SET_CATALOG_REMOVE_CLASS_TYPE:
            return {
                ...state,
                isCatalogClassTypeRemoved: action.isCatalogClassTypeRemoved,
            };
        case SET_CATALOG_UPDATE_GROSS_WEIGHT:
            return {
                ...state,
                catalogUpdateGrossWeight: action.catalogUpdateGrossWeight,
            };
        case SET_CATALOG_UPDATE_GROSS_WEIGHT_SAVE:
            return {
                ...state,
                isCatalogUpdateGrossWeightSaved: action.isCatalogUpdateGrossWeightSaved,
            };
        case SET_CATALOG_UPDATE_GROSS_WEIGHT_VALIDATE:
            return {
                ...state,
                isCatalogUpdateGrossWeightValid: action.isCatalogUpdateGrossWeightValid,
            };
        case SET_CATALOG_REMOVE_GROSS_WEIGHT:
            return {
                ...state,
                isCatalogGrossWeightRemoved: action.isCatalogGrossWeightRemoved,
            };
        case SET_CATALOG_UPDATE_TRIM:
            return {
                ...state,
                catalogUpdateTrim: action.catalogUpdateTrim,
            };
        case SET_CATALOG_UPDATE_TRIM_SAVE:
            return {
                ...state,
                isCatalogUpdateTrimSaved: action.isCatalogUpdateTrimSaved,
            };
        case SET_CATALOG_UPDATE_TRIM_VALIDATE:
            return {
                ...state,
                isCatalogUpdateTrimValid: action.isCatalogUpdateTrimValid,
            };
        case SET_CATALOG_REMOVE_TRIM:
            return {
                ...state,
                isCatalogTrimRemoved: action.isCatalogTrimRemoved,
            };
        default:
            return state;
    }
};

export default reducer;
